// hooks/usePrenom.js
import { firstnames } from "../data/firstnames";

export function useFirstname() {
  const getRandomFirstname = (genre = "male") => {
    const liste = firstnames[genre] || firstnames["male"];
    const index = Math.floor(Math.random() * liste.length);
    return liste[index];
  };

  return { getRandomFirstname };
}
